import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PositionApplicationType } from './position-application-type.interface';
import { PositionApplicationTypeService } from './position-application-type.service';
const service = new PositionApplicationTypeService();

export interface PositionApplicationTypeState {
   positionApplicationTypes: Array<PositionApplicationType>;
}

const PositionApplicationTypeStore: Module<PositionApplicationTypeState, StoreState> = {
   namespaced: true,
   state: {
      positionApplicationTypes: [],
   },
   getters: {
      positionApplicationTypes: (state) => state.positionApplicationTypes,
   },
   mutations: {
      SET_POSITION_DESCRIPTION_TYPES(state, positionApplicationTypes: Array<PositionApplicationType>) {
         state.positionApplicationTypes = positionApplicationTypes;
      },
   },
   actions: {
      async getPositionApplicationTypes(context) {
         const response = await service.getPositionApplicationTypes();
         context.commit('SET_POSITION_DESCRIPTION_TYPES', response.data);
         return response;
      },
   },
};

export default PositionApplicationTypeStore;
